document.documentElement.classList.add('js');

/* Shop preview behaviour: option chips, quantity and the gallery. Nothing here
   talks to a cart — on Shopify the theme's own product form does that. */
(function(){
  function group(el){ return el.parentElement.querySelectorAll('[aria-pressed]'); }
  document.querySelectorAll('.sh-chip').forEach(function(b){
    b.addEventListener('click', function(){
      group(b).forEach(function(o){ o.setAttribute('aria-pressed','false'); });
      b.setAttribute('aria-pressed','true');
    });
  });
  var qty = document.getElementById('shqty');
  if(qty){
    document.querySelectorAll('.sh-qty button').forEach(function(b){
      b.addEventListener('click', function(){
        var n = parseInt(qty.value,10) || 1;
        qty.value = Math.min(99, Math.max(1, n + parseInt(b.dataset.step,10)));
      });
    });
  }
  var quote = document.getElementById('shquote');
  if(quote){
    quote.addEventListener('submit', function(e){
      e.preventDefault();
      quote.querySelectorAll('.sh-err').forEach(function(n){ n.remove(); });
      var bad = [].slice.call(quote.querySelectorAll('[required]'))
                  .filter(function(f){ return !f.value.trim(); });
      if(bad.length){
        bad.forEach(function(f){
          var m = document.createElement('div');
          m.className = 'sh-err';
          m.textContent = 'We need this one';
          f.parentNode.appendChild(m);
        });
        bad[0].focus();
        return;
      }
      document.getElementById('shquotenote').textContent =
        'Prototype only — nothing was sent.';
    });
  }
  var main = document.getElementById('shmain');
  if(main){
    document.querySelectorAll('.sh-thumbs button').forEach(function(b){
      b.addEventListener('click', function(){
        document.querySelectorAll('.sh-thumbs button').forEach(function(o){
          o.setAttribute('aria-current','false');
        });
        b.setAttribute('aria-current','true');
        main.src = b.dataset.src;
        main.alt = b.querySelector('img').alt;
      });
    });
  }
})();
